import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createCarbonProgramDraft } from "services";

import { CREATE_CARBON_PROGRAM_DRAFT, GET_CARBON_PROGRAM_DRAFT, GET_CARBON_PROGRAM_DRAFTS } from "consts";

export const useCreateCarbonProgramDraft = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [CREATE_CARBON_PROGRAM_DRAFT],
    mutationFn: createCarbonProgramDraft,
    onSuccess: (draft) => {
      queryClient.invalidateQueries({ queryKey: [GET_CARBON_PROGRAM_DRAFTS] });
      queryClient.setQueryData([GET_CARBON_PROGRAM_DRAFT, draft.id], draft);
    },
  });
};
